import { BaseModel } from '../../shared/entities/base.model';

export class JobTypeModel extends BaseModel {
    id: number = null;
    uid: string;
    name: number;
    created_at: Date;
    updated_at: Date;
}
